// Credit: https://gitlab.td.gfk.com/ecosystem/brand-manager-pkg/-/blob/master/src/pages/RevenuePremium/MarketLandscape/Graph/quadrants.ts

import Highcharts from 'highcharts';
import { leftIconLabel, rightIconLabel, TooltipPosition } from './Tooltip';
import { MutableRefObject } from 'react';

const QUADRANTS = {
  topLeft: 'Ahead on Growth but behind on Fair Share',
  topRight: 'Ahead on both Growth and Fair Share',
  bottomLeft: 'Behind on both Growth and Fair Share',
  bottomRight: 'Behind on Growth but ahead on Fair Share',
};

type QuadrantRefs = {
  topLeftLabel: MutableRefObject<Highcharts.SVGElement | null>;
  topRightLabel: MutableRefObject<Highcharts.SVGElement | null>;
  bottomLeftLabel: MutableRefObject<Highcharts.SVGElement | null>;
  bottomRightLabel: MutableRefObject<Highcharts.SVGElement | null>;
};

export function clear(quadrants: QuadrantRefs): void {
  const { topLeftLabel, topRightLabel, bottomLeftLabel, bottomRightLabel } = quadrants;

  topLeftLabel.current?.destroy();
  topRightLabel.current?.destroy();
  bottomLeftLabel.current?.destroy();
  bottomRightLabel.current?.destroy();
}

export function drawAllAnnotations(
  this: Highcharts.Chart,
  quadrants: QuadrantRefs,
  isExportModalOpen: boolean,
): void {
  const { topLeftLabel, topRightLabel, bottomLeftLabel, bottomRightLabel } = quadrants;

  topLeftLabel.current = this.renderer
    .text(
      leftIconLabel('Opportunity', QUADRANTS.topLeft, TooltipPosition.TOP_LEFT, isExportModalOpen),
      undefined,
      undefined,
      true,
    )
    .add();
  topLeftLabel.current.attr({
    x: this.plotLeft,
    y: this.plotTop - topLeftLabel.current.getBBox().height,
  });

  topRightLabel.current = this.renderer
    .text(
      rightIconLabel('Strength', QUADRANTS.topRight, TooltipPosition.TOP_RIGHT, isExportModalOpen),
      undefined,
      undefined,
      true,
    )
    .add();
  topRightLabel.current.attr({
    x: this.plotLeft + this.plotWidth - topRightLabel.current.getBBox().width,
    y: this.plotTop - topRightLabel.current.getBBox().height,
  });

  bottomLeftLabel.current = this.renderer
    .text(
      leftIconLabel(
        'Weakness',
        QUADRANTS.bottomLeft,
        TooltipPosition.BOTTOM_LEFT,
        isExportModalOpen,
      ),
      this.plotLeft,
      this.plotTop + this.plotHeight + 60,
      true,
    )
    .add();

  bottomRightLabel.current = this.renderer
    .text(
      rightIconLabel(
        'Threat',
        QUADRANTS.bottomRight,
        TooltipPosition.BOTTOM_RIGHT,
        isExportModalOpen,
      ),
      undefined,
      undefined,
      true,
    )
    .add();
  bottomRightLabel.current.attr({
    x: this.plotLeft + this.plotWidth - bottomRightLabel.current.getBBox().width,
    y: this.plotTop + this.plotHeight + 60,
  });
}
